export const COUPON_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  EXPIRED: "expired",
  SCHEDULED: "scheduled",
};

export const COUPON_STATUS_LABELS = {
  [COUPON_STATUS.ACTIVE]: "Active",
  [COUPON_STATUS.INACTIVE]: "Inactive",
  [COUPON_STATUS.EXPIRED]: "Expired",
  [COUPON_STATUS.SCHEDULED]: "Scheduled",
};

export const COUPON_CATEGORY = {
  DYNAMIC: "Dynamic",
  REFERRAL: "REFERRAL",
  RENEWAL: "RENEWAL",
  BUNDLE_DISCOUNT: "bundlediscount",
};

export const COUPON_CATEGORIES = Object.values(COUPON_CATEGORY);

export const COUPON_CATEGORY_LABELS = {
  [COUPON_CATEGORY.DYNAMIC]: "Dynamic",
  [COUPON_CATEGORY.REFERRAL]: "Referral",
  [COUPON_CATEGORY.RENEWAL]: "Renewal",
  [COUPON_CATEGORY.BUNDLE_DISCOUNT]: "Bundle Discount",
};

export const COUPON_CATEGORY_OPTIONS = [
  {
    id: COUPON_CATEGORY.BUNDLE_DISCOUNT,
    label: COUPON_CATEGORY_LABELS[COUPON_CATEGORY.BUNDLE_DISCOUNT],
  },
];

export const ZERO = 0;

export const ACTIVE_COUPONS_DEFAULT_OFFSET = ZERO;

export const ACTIVE_COUPONS_DEFAULT_LIMIT = 10;

export const COUPON_COPY_FEEDBACK_DURATION_MS = 2000;

export const COUPON_PREVIEW_LIST_SCROLL_THRESHOLD = 4;

export const COUPON_FORM_DEFAULT_STEP_ID = 1;

export const MDS_RESOURCE_TYPES = {
  VERTICAL: "vertical",
  CURRENCY: "currency",
  COUNTRY: "country",
};

export const COUPON_PREVIEW_NOT_SET = "Not set";

export const COUPON_LOCKED_IN_EDIT_FIELDS = [
  "code",
  "category",
  "verticalId",
  "tenantIds",
  "currencyId",
  "effectiveDate",
  "discountType",
  "discountValue",
  "isApplicableForSingleUser",
  "uamId",
];

export const CREATE_COUPON_DEFAULT_VALUES = {
  verticalId: "",
  tenantIds: [],
  currencyId: "",
  currencySettings: {},
  code: "",
  category: "",
  remarks: "",
  discountType: "",
  discountValue: "",
  maxAllowedAmount: "",
  effectiveDate: "",
  expiryDate: "",
  totalCouponCount: "",
  isApplicableMultipleTimes: false,
  isApplicableForSingleUser: false,
  uamId: "",
  minimumPackageMrp: "",
  minimumCartMrp: "",
  selectAllPackages: false,
  packageIds: [],
  selectAllPlatforms: false,
  platformIds: [],
};

export const PLATFORM_UI_DESCRIPTIONS = {
  web: "Infinity Learn Website",
  android: "Infinity Learn Android Application",
  ios: "Infinity Learn iOS Application",
};

export const COUPON_VALIDATION = {
  MAX_COUPON_CODE_LENGTH: 100,
  MAX_COUPON_REMARKS_LENGTH: 100,
  COUPON_CODE_REGEX: "^[A-Za-z0-9][A-Za-z0-9_-]*$",
  MAX_ALLOWED_EFFECTIVE_DATE_OFFSET_DAYS: 90,
  MIN_EXPIRY_DATE_AFTER_EFFECTIVE_DAYS: 1,
  MAX_EXPIRY_DATE_AFTER_EFFECTIVE_DAYS: 370,
  MAX_DISCOUNT_DECIMAL_PLACES: 2,
  MIN_PERCENTAGE_DISCOUNT: ZERO,
  MAX_PERCENTAGE_DISCOUNT: 100,
  MIN_FLAT_DISCOUNT_AMOUNT: ZERO,
  MAX_FLAT_DISCOUNT_AMOUNT: 100000,
  MIN_TOTAL_COUPON_COUNT: 1,
  MAX_TOTAL_COUPON_COUNT: 200000,
  MIN_MRP_AMOUNT: ZERO,
  ALL_PACKAGES_ID: ZERO,
  ALL_PLATFORMS_ID: 1,
};

export const DISCOUNT_TYPES = {
  FLAT: "flat",
  PERCENTAGE: "percentage",
};

export const DISCOUNT_TYPE_OPTIONS = [
  { id: DISCOUNT_TYPES.FLAT, label: "Flat" },
  { id: DISCOUNT_TYPES.PERCENTAGE, label: "Percentage" },
];

export const PLATFORM_ENUMS = {
  ALL: { platformId: 1, key: "all", label: "All" },
  ANDROID: { platformId: 2, key: "android", label: "Android" },
  IOS: { platformId: 3, key: "ios", label: "iOS" },
  WEB: { platformId: 4, key: "web", label: "Web" },
};

export const PLATFORM_ENUM_OPTIONS = [
  PLATFORM_ENUMS.ANDROID,
  PLATFORM_ENUMS.IOS,
  PLATFORM_ENUMS.WEB,
];

export const ALLOWED_PLATFORM_IDS = PLATFORM_ENUM_OPTIONS.map(
  (platform) => platform.platformId,
);

export const COUPON_FORM_STEPS = [
  {
    id: 1,
    label: "Basic Info",
    title: "Basic Information",
    subtitle: "Choose discount type, tenants, and coupon details",
    iconName: "article",
  },
  {
    id: 2,
    label: "Validity",
    title: "Validity",
    subtitle: "Set effective and expiry dates",
    iconName: "dateRange",
  },
  {
    id: 3,
    label: "Discount",
    title: "Discount",
    subtitle: "Set discount and per-currency amounts",
    iconName: "localOffer",
  },
  {
    id: 4,
    label: "Usage Limits",
    title: "Usage Limits",
    subtitle: "Set coupon usage restrictions",
    iconName: "barChart",
  },
  {
    id: 5,
    label: "Packages",
    title: "Packages",
    subtitle: "Select packages where this coupon can be applied",
    iconName: "inventory",
  },
  {
    id: 6,
    label: "Platforms",
    title: "Platforms",
    subtitle: "Choose platforms where this coupon can be used",
    iconName: "devices",
  },
];

export const COUPON_FORM_VIEW_SUBTITLES = {
  1: "Discount type, tenants, code, category, and remarks",
  2: "Active period and current status",
  3: "Discount value and per-currency amounts",
  4: "Total usage and per-user restrictions",
  5: "Packages where this coupon applies",
  6: "Platforms where this coupon can be used",
};

